import React from 'react';
import { AreaSVGProps } from '../VehiclePaintMeasurement.types';

export const AreaB_Hatchback_Center: React.FC<AreaSVGProps> = ({
  fill = '#73C69B',
  stroke = '#73C69B',
  strokeWidth = 2,
  fillOpacity = 0.5,
  className = '',
}) => {
  return (
    <svg
      width="188"
      height="330"
      viewBox="0 0 188 330"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        <filter
          id="filter_area_b_hatchback_center"
          x="0"
          y="0"
          width="188"
          height="330"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
      </defs>
      <g filter="url(#filter_area_b_hatchback_center)">
        <path
          d="M93.5947 0C131.912 0.0519982 165.43 4.31376 187.188 10.9043C185.598 25.7445 184.335 39.5511 183.31 52.9521L182.854 59.0879V59.0908C181.696 75.3788 172.531 200.282 168.709 236.058L168.708 236.071L168.706 236.086L168.705 236.101C168.7 236.145 168.706 236.086 168.706 236.086V236.089C168.706 236.091 168.706 236.096 168.705 236.101C168.704 236.11 168.702 236.125 168.7 236.145C168.696 236.184 168.69 236.242 168.683 236.319C168.667 236.473 168.645 236.702 168.615 237C168.556 237.597 168.468 238.473 168.356 239.59C168.133 241.823 167.815 245.018 167.43 248.865C166.66 256.56 165.627 266.863 164.576 277.296C162.75 295.43 160.883 313.793 160.234 319.693C153.603 323.658 138.576 329.287 93.7344 329.825C48.8756 329.291 33.4408 323.565 26.7529 319.588C26.1158 313.69 24.2962 295.362 22.5146 277.254C21.4895 266.834 20.4822 256.545 19.7314 248.86C19.3561 245.018 19.0456 241.827 18.8281 239.597C18.7194 238.482 18.6342 237.607 18.5762 237.011C18.5471 236.713 18.5247 236.484 18.5098 236.33C18.5023 236.253 18.496 236.194 18.4922 236.155C18.4873 236.101 18.4883 236.111 18.4883 236.111L18.4834 236.06L18.1094 232.451C14.6167 197.73 7.61436 103.952 5.125 69.9062L4.3418 59.0938V59.0918L3.88672 52.9551C2.86163 39.5532 1.58919 25.7466 0 10.9092C21.7579 4.31595 55.2725 0.0520566 93.5947 0Z"
          fill={fill}
          fillOpacity={fillOpacity}
          stroke={stroke}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
          shapeRendering="crispEdges"
        />
      </g>
    </svg>
  );
};
